<template>
  <div class="filters">
    <div class="filters__container">
      <div class="filters__group">
        <c-input
          ref="date"
          v-model="form.date"
          class="filters__item filters__date"
          label="Дата"
          :editable="true"
          type="date"
          format="DD.MM.YYYY, dddd"
          icon="calendar"
          placeholder="00.00.0000"
          :required="dateError"
          :required-condition="dateError"
          :required-message="dateError"
          :icon-right="true"
          :clearable="true"
          @invalidDate="onInvalidDate"
        />
        <c-input
          v-model="form.filials"
          class="filters__item filters__filials"
          type="select"
          label="Филиал сотрудника"
          :checkbox="true"
          :checkbox-value="form.filialsExcept"
          :checkbox-type="'icon'"
          :checkbox-tooltip="checkboxTooltip"
          :multiple="true"
          :searchable="true"
          :clearable="true"
          placeholder="Все"
          :items="collections.filials"
          @checkboxChange="form.filialsExcept = $event"
        />
        <c-input
          v-model="form.positions"
          class="filters__item filters__positions"
          type="select"
          label="Должность"
          :checkbox="true"
          :checkbox-value="form.positionsExcept"
          :checkbox-type="'icon'"
          :checkbox-tooltip="checkboxTooltip"
          :multiple="true"
          :searchable="true"
          :clearable="true"
          placeholder="Все"
          :items="collections.positions"
          @checkboxChange="form.positionsExcept = $event"
        />
        <c-input
          v-model="form.workerStatus"
          class="filters__item filters__worker-statuses"
          type="select"
          label="Статус сотрудника"
          :checkbox="true"
          :checkbox-value="form.workerStatusExcept"
          :checkbox-type="'icon'"
          :checkbox-tooltip="checkboxTooltip"
          :multiple="true"
          :searchable="true"
          :clearable="true"
          placeholder="Все"
          :items="collections.workerStatus"
          @checkboxChange="form.workerStatusExcept = $event"
        />
        <c-input
          v-model="form.filialTransaction"
          class="filters__item filters__filials"
          type="select"
          label="Филиал проводок"
          :multiple="false"
          :searchable="true"
          :clearable="true"
          placeholder="Все"
          :items="collections.filials"
          @checkboxChange="form.filialsExcept = $event"
        />        
        <div class="filters__item filters-actions">
          <div class="filters-actions__container">
            <c-button class="filters__reset" size="large" label="Сбросить" @click="reset" />
            <c-button class="filters__apply" label="Применить" color="blue" size="large" @click="apply" />
          </div>
        </div>
      </div>

      <!--      <div class="filters__group second-group">-->
      <!--        -->
      <!--        -->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { nowToString } from "@/utils/date/now";
import { isDateValid } from "@/utils/date/valid";
import Input from "@/components/controls2/Input";
import Button from "@/components/controls/button";

const checkboxTooltip = {
  disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
  activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
  notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
};

export default {
  name: "debt-report-filters",

  components: {
    "c-input": Input,
    "c-button": Button,
  },

  data() {
    return {
      submitted: false,

      checkboxTooltip,

      form: {
        date: nowToString(),
        filialTransaction: null,
        filials: [],
        filialsExcept: false,
        positions: [],
        positionsExcept: false,
        workerStatus: [],
        workerStatusExcept: false,
      },

      formatErrors: {
        date: false,
        dateFix: false,
      },

      collections: {
        filials: [],
        positions: [],
        workerStatus: [],
      },
    };
  },

  computed: {
    dateError() {
      if (!this.submitted) return null;
      if (!this.form.date) return "Обязательное поле";
      if (this.formatErrors.date) return "Некорректный формат";
      return null;
    },

    isValid() {
      return !this.dateError;
    },
  },

  watch: {
    "form.date": function (v) {
      if (this.formatErrors.dateFix) {
        this.formatErrors.dateFix = false;
        return;
      }
      this.formatErrors.date = !isDateValid(v);
    },
    "form.workerStatus": {
      handler(v) {
        if (!v.length) {
          this.form.workerStatusExcept = false;
        }
      },
      deep: true,
    },
    "form.filials": {
      handler(v) {
        if (!v.length) {
          this.form.filialsExcept = false;
        }
      },
      deep: true,
    },
    "form.positions": {
      handler(v) {
        if (!v.length) {
          this.form.positionsExcept = false;
        }
      },
      deep: true,
    },
  },

  created() {
    this.$store.dispatch("debtReport/loadFilters").then((res) => {
      res.forEach((filter) => {
        if (filter.code === "posts") {
          this.collections.positions = (filter.values || []).map((v) => ({
            value: v.id,
            label: v.name,
          }));
        }
        if (filter.code === "workerStatus") {
          this.collections.workerStatus = (filter.values || []).map((status) => ({
            value: status.id,
            label: status.name,
          }));
        }

        if (filter.code === "filial" && filter.values) {
          this.collections.filials = (filter.values || []).map((v) => ({
            value: v.id,
            label: v.name,
          }));
        }    

        console.log(filter);
      });
      console.log(this.collections)
      this.setDefaultParams();
      this.$emit("inited");
    });
  },

  methods: {
    onInvalidDate(e) {
      if (e) {
        this.formatErrors.date = true;
        this.formatErrors.dateFix = true;
      }
    },

    apply() {
      this.submitted = true;
      if (!this.isValid) return;
      this.submitted = false;
      this.$emit("apply");
    },

    reset() {
      const now = nowToString();
      this.$refs.date.setDateInputTypeDate(now);
      this.form.date = now;
      this.form.filials = [];
      this.form.filialTransaction = null;
      this.form.filialsExcept = false;
      this.form.positions = [];
      this.form.positionsExcept = false;
      this.form.workerStatus = [];
      this.form.workerStatusExcept = false;
      this.submitted = false;
      this.$emit("reset");
      this.$emit("apply");
    },

    getParams() {
      const filters = {};

      if (this.form.date) {
        filters.dateForPersonalAccountBalance = {
          value: this.form.date,
        };
      }

      if (this.form.filialTransaction) {
        filters.filialTransaction = {
          value: this.form.filialTransaction.value,
        };
      }

      if (this.form.positions.length) {
        filters.posts = {
          values: this.form.positions.map((p) => p.value).join(","),
          search_type: this.form.positionsExcept ? 2 : 1,
        };
      }

      if (this.form.filials.length) {
        filters.filial = {
          values: this.form.filials.map((p) => p.value).join(","),
          search_type: this.form.filialsExcept ? 2 : 1,
        };
      }

      if (this.form.workerStatus.length) {
        filters.workerStatus = {
          values: this.form.workerStatus.map((status) => status.value).join(","),
          search_type: this.form.workerStatusExcept ? 2 : 1,
        };
      }

      return filters;
    },

    getUrlParams() {
      return {
        "filters[filials]": this.form.filials.map((p) => p.value).join(","),
        "filters[filialTransaction]": this.form.filialTransaction ? this.form.filialTransaction.value : null,
        "filters[filialsExcept]": this.form.filialsExcept ? 1 : 0,
        "filters[posts]": this.form.positions.map((p) => p.value).join(","),
        "filters[postsExcept]": this.form.positionsExcept ? 1 : 0,
        "filters[date]": this.form.date,
        "filters[workerStatus]": this.form.workerStatus.map((status) => status.value).join(","),
        "filters[workerStatusExcept]": this.form.workerStatusExcept ? 1 : 0,
      };
    },

    setDefaultParams() {
      const sp = this.$route.query;

      if (sp["filters[filialTransaction]"]) {
        const filialsCollection = this.collections.filials;
        var index = filialsCollection.findIndex((i)=>i.value==sp["filters[filialTransaction]"]);
        this.form.filialTransaction = filialsCollection[index];
      }

      if (sp["filters[filials]"]) {
        const filialsCollection = this.collections.filials;
        this.form.filials = sp["filters[filials]"]
          .split(",")
          .map((fId) => filialsCollection.find((f) => f.value.toString() === fId.toString()))
          .filter(Boolean);

        this.form.filialsExcept = sp["filters[filialsExcept]"] === "1";
      }

      if (sp["filters[posts]"]) {
        const positionsCollection = this.collections.positions;
        this.form.positions = sp["filters[posts]"]
          .split(",")
          .map((pId) => positionsCollection.find((p) => p.value.toString() === pId.toString()))
          .filter(Boolean);

        this.form.positionsExcept = sp["filters[postsExcept]"] === "1";
      }

      if (sp["filters[date]"]) {
        this.form.date = sp["filters[date]"];

        if (this.$refs.date) this.$refs.date.setDateInputTypeDate(this.form.date);
      }

      if (sp["filters[workerStatus]"]) {
        const workerStatusCollection = this.collections.workerStatus;
        this.form.workerStatus = sp["filters[workerStatus]"]
          .split(",")
          .map((statusId) => workerStatusCollection.find((s) => s.value.toString() === statusId.toString()))
          .filter(Boolean);

        this.form.workerStatusExcept = sp["filters[workerStatusExcept]"] === "1";
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./style.scss"></style>
